module.exports = __webpack_public_path__ + "static/FormTemplateEditor-6ab73aa61f6394e0a7c0659053f09bf5.png";